import React from 'react';
import { SystemStatusList } from '../SystemStatus/SystemStatusList';
import { Instance } from 'mobx-state-tree';
import { Secretariat, SystemStatus } from '../../store/models';
import { Translate } from '../common/WithTranslate';

interface SecretariatSystemStatusProps {
  systemStatuses: Array<Instance<typeof SystemStatus>>;
  secretariat?: Instance<typeof Secretariat>;
  translate: Translate;
  navigate: (url: string) => void;
}

export const SecretariatSystemStatus = ({
  systemStatuses,
  secretariat,
  translate,
  navigate,
}: SecretariatSystemStatusProps) => {
  return (
    <SystemStatusList
      systemStatuses={
        secretariat === undefined ? [] : systemStatuses.filter((ss) => ss.secretariatId === secretariat.secretariatId)
      }
      secretariats={secretariat === undefined ? [] : [secretariat]}
      translate={translate}
      navigate={navigate}
    />
  );
};
